import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';
import { Entity } from '../../../_core/state/entities.model';
import { AssetDto } from '../../../../../../api/src/asset/models/asset.dto';
import { ImagePickerActionsDto } from '../../../../../../api/src/creative-unit-package/models/customization/customization.dto';
import { ImageActionType } from '../../../../../../api/src/asset/models/image-action.dto';

@Component({
	selector: 'app-image-editor-sidebar',
	templateUrl: './image-editor-sidebar.component.html',
	styleUrls: ['./image-editor-sidebar.component.scss']
})
export class ImageEditorSidebarComponent implements OnInit, OnChanges {
	@Input() activeAsset: AssetDto;
	@Input() config: ImagePickerActionsDto;
	@Input() set activeToolOptionInput(value: Entity) {
		if (value && value !== this.activeToolOption) {
			this.activeToolOption = value;
		}
	}
	@Output() setActiveAsset: EventEmitter<AssetDto> = new EventEmitter<AssetDto>();
	@Output() setActiveVariations: EventEmitter<Partial<AssetDto>[]> = new EventEmitter<Partial<AssetDto>[]>();
	@Output() setActiveToolOption: EventEmitter<Entity> = new EventEmitter<Entity>();
	@Output() setConfig: EventEmitter<ImagePickerActionsDto> = new EventEmitter<ImagePickerActionsDto>();
	@Output() setLoadingMessage: EventEmitter<string | null> = new EventEmitter<string | null>();
	@Output() setFilteredTools: EventEmitter<Entity[]> = new EventEmitter<Entity[]>();

	public toolOptions: Entity[] = [
		{
			id: 'background',
			name: 'Background',
			icon: 'landscape',
			tools: [
				ImageActionType.BackgroundRemoval,
				ImageActionType.ReplaceBackground,
				ImageActionType.BlurBackground,
				ImageActionType.EnhanceImage
			]
		},
		{
			id: 'text-to-image',
			name: 'Text to Image',
			icon: 'auto_awesome',
			tools: [ImageActionType.TextToImage]
		},
		{
			id: 'edit-image',
			name: 'Edit Image',
			icon: 'auto_fix_high',
			tools: [ImageActionType.EditImageWithText]
		},
		{
			id: 'target-crop',
			name: 'Focal Area Crop',
			icon: 'crop',
			tools: [ImageActionType.TargetCrop],
			config: {
				hideUndoRedo: true
			}
		},
		{
			id: 'bria-iframe',
			name: 'Bria Image Editor',
			icon: 'edit',
			tools: [ImageActionType.BriaIframe],
			config: {
				hideFooter: true,
				noPadding: true
			}
		},
		{
			id: 'photopea-iframe',
			name: 'Photopea Editor',
			icon: 'brush',
			tools: [ImageActionType.PhotopeaIframe],
			config: {
				hideFooter: false,
				noPadding: true,
				minimizeSidebar: true,
				hideUndoRedo: true
			}
		}
	];
	filteredToolOptions: Entity[] = [];
	activeToolOption: Entity;

	constructor() {}

	ngOnInit(): void {
		this.filteredToolOptions = [...this.toolOptions];

		if (this.config?.showActions?.length) {
			// Filter the tool options tools array to only include the tools that are in the config.
			this.filteredToolOptions = this.filteredToolOptions.map(option => {
				option.tools = option.tools.filter((tool) => this.config.showActions?.includes(tool as ImageActionType));
				return option;
			});
		}

		if (this.config?.hideActions?.length) {
			// Filter the tool options tools array to exclude the tools that are in the config.
			this.filteredToolOptions = this.filteredToolOptions.map(option => {
				option.tools = option.tools.filter(tool => !this.config.hideActions.includes(tool));
				return option;
			});
		}

		// Remove any tool options that have no tools.
		this.filteredToolOptions = this.filteredToolOptions.filter(option => option.tools.length > 0);

		// Emit filtered tools to parent for sidebar display
		this.setFilteredTools.emit(this.filteredToolOptions);

		if (!this.activeAsset) {
			this.activeToolOption =
				this.filteredToolOptions.find(option => option.id === ImageActionType.TextToImage) || this.toolOptions[0];
		} else {
			this.activeToolOption = this.filteredToolOptions[0];
		}

		this.setActiveToolOption.emit(this.activeToolOption);
	}

	ngOnChanges(changes: SimpleChanges): void {}

	setActiveTool(tool: Entity) {
		this.activeToolOption = tool;
		this.setActiveToolOption.emit(tool);
	}

	setConfigValue(config: Partial<ImagePickerActionsDto>) {
		this.setConfig.emit({
			...this.config,
			...config
		});
	}
}
